import { Tag } from '@omnipresentgroup/design-system';
import { getTimeOffStatusIntent } from '@omnipresentgroup/domains';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import type { TimeOff } from '@omnipresentgroup/types';

type Props = {
  timeOff: TimeOff;
};

export const TimeOffStatusTag = ({ timeOff }: Props) => (
  <Tag id={timeOff.id} intent={getTimeOffStatusIntent(timeOff)}>
    {toSentenceCase(timeOff.status)}
  </Tag>
);
